import React from 'react';
import ReactPlayer from 'react-player';
import Select from '../../../../../components/input/Select';
import Modal from '../../../../../components/Modal';
import InputForm from '../../../../../components/form/InputForm';
import { addAllItemToSelectList } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import { REX_YOUTUBE_OR_VIMEO_URL } from '../../../../../lib/rex';
import {
  VIDEO_RATIO_TYPE_SELECT_LIST,
  VIDEO_RATIO_TYPE_VALUE,
} from '../../../../../constants/service/common/commonConstants';
import './VideoUploadModal.scss';

const VideoUploadModal = (props) => {
  const { form, isOpen, setData, url, width, height, onSubmit, closeModal } = props;

  return (
    <Modal
      title="영상 업로드"
      onClose={() => closeModal()}
      isOpen={isOpen}
      width={500}
      height={530}
      isFooter={true}
      onOk={() => onSubmit()}
    >
      <div className="video-upload-modal">
        <ReactPlayer className="react-player" width={470} height={280} controls={true} url={url} />

        <InputForm
          label="영상 url"
          form={form}
          rules={[
            formRequiredRules(true, '필수사항 입니다.'),
            {
              pattern: REX_YOUTUBE_OR_VIMEO_URL,
              message: '유효하지 않은 영상 url 입니다.',
            },
          ]}
          initialValue={url}
          onChange={(value) =>
            setData({
              name: 'url',
              value,
            })
          }
          size="large"
          name="url"
        />

        <InputForm
          label="앱에서 노출될 너비"
          type="number"
          form={form}
          rules={[formRequiredRules(true, '필수사항 입니다.', false)]}
          initialValue={width}
          onChange={(value) =>
            setData({
              name: 'width',
              value,
            })
          }
          min={300}
          max={1000}
          addonAfter="px"
          name="width"
        />

        <InputForm
          label="앱에서 노출될 높이"
          type="number"
          form={form}
          rules={[formRequiredRules(true, '필수사항 입니다.', false)]}
          initialValue={height}
          onChange={(value) =>
            setData({
              name: 'height',
              value,
            })
          }
          min={300}
          max={1000}
          addonAfter="px"
          name="height"
        />

        <Select
          list={addAllItemToSelectList(VIDEO_RATIO_TYPE_SELECT_LIST, '비율선택')}
          onChange={(type) => {
            setData({
              name: 'width',
              value: VIDEO_RATIO_TYPE_VALUE[type].width,
            });
            setData({
              name: 'height',
              value: VIDEO_RATIO_TYPE_VALUE[type].height,
            });
            form.setFieldsValue({
              width: VIDEO_RATIO_TYPE_VALUE[type].width,
              height: VIDEO_RATIO_TYPE_VALUE[type].height,
            });
          }}
          value={null}
          size="large"
        />
      </div>
    </Modal>
  );
};

export default VideoUploadModal;
